










































import Vue from 'vue';
import Component from 'vue-class-component';
import TextInput from '@/components/TextInput.vue';

const InitiativeInputProps = Vue.extend({
  props: {
    label: String,
    base: Number,
    dice: Number,
    unavailable: Boolean,
    readonly: Boolean,
    baseReadOnly: Boolean,
  },
});

@Component({
  components: { TextInput },
})
export default class InitiativeInput extends InitiativeInputProps {
  baseChanged(value: string) {
    this.$emit('baseValue', Number.parseInt(value, 10));
  }

  diceChanged(value: string) {
    this.$emit('diceValue', Number.parseInt(value, 10));
  }
}
